/* Sample Agency — demosong player.

   Один <audio> на всі вейвформи сторінки: компактна в байбоксі і широка замість
   ютуб-демо. Обидві малюють ту саму доріжку і ходять у зв'язці — грають, стають
   на паузу і перемотуються разом, бо media-елемент у них спільний.
   Реєструємо в window.globalAudioPlayers ЛИШЕ майстра: інакше stopGlobalPlayers
   зупинить спільне audio, коли демо саме його і запустило.

   Вигляд хвилі: поки не торкались — обкладинка на повну яскравість. Як тільки
   пішло відтворення, непрослухане притемнюється, і обкладинка «повертається»
   по мірі програвання. */
(function () {
  if (window.SADemo) return;

  var ICON_PLAY =
    '<svg viewBox="-3 0 28 28" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">' +
    '<path d="M440.415,583.554 L421.418,571.311 C420.291,570.704 419,570.767 419,572.946 L419,597.054 ' +
    'C419,599.046 420.385,599.36 421.418,598.689 L440.415,586.446 C441.197,585.647 441.197,584.353 440.415,583.554" ' +
    'transform="translate(-419, -571)"></path></svg>';
  var ICON_PAUSE =
    '<svg viewBox="-1 0 8 8" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">' +
    '<path d="M172,3605 C171.448,3605 171,3605.448 171,3606 L171,3612 C171,3612.552 171.448,3613 172,3613 ' +
    'C172.552,3613 173,3612.552 173,3612 L173,3606 C173,3605.448 172.552,3605 172,3605 M177,3606 L177,3612 ' +
    'C177,3612.552 176.552,3613 176,3613 C175.448,3613 175,3612.552 175,3612 L175,3606 C175,3605.448 175.448,3605 ' +
    '176,3605 C176.552,3605 177,3605.448 177,3606" transform="translate(-171, -3605)"></path></svg>';

  function fmt(sec) {
    if (!isFinite(sec) || sec < 0) sec = 0;
    sec = Math.floor(sec);
    var m = Math.floor(sec / 60);
    var s = sec % 60;
    return m + ':' + (s < 10 ? '0' : '') + s;
  }

  var S = {
    url: null,
    audio: null,
    master: null,
    views: [],
    peaks: null,
    duration: 0,
    artUrl: null,
    artImg: null,
    engaged: false,
    seekTo: null
  };

  /* ---------- обкладинка ---------- */

  /* Картинка одна на всі вейвформи: один запит і однакове кадрування.
     🔑 Інстанси wavesurfer створюємо ТІЛЬКИ коли вона вже завантажена. Перший
     рендер іде мікротаском одразу після create, тобто ЗАВЖДИ раніше за onload
     картинки — і плеєр лишається залитим запасним кольором. Таймаут на випадок
     мертвого файлу. */
  function whenArtReady(cb) {
    if (!S.artUrl) return cb();
    if (!S.artImg) {
      S.artImg = new Image();
      S.artImg.crossOrigin = 'anonymous';
      /* 🔑 Картинка з CDN буває їде довго (на холодному кеші міряли 5,8 с), тож
         чекати її безкінечно не можна — але й кинути не можна: хто дочекався
         таймауту, отримає хвилю фірмовим кольором і мусить перемалюватись, коли
         обкладинка нарешті приїде. */
      S.artImg.addEventListener('load', repaintArt);
      S.artImg.src = S.artUrl;
    }
    var img = S.artImg;
    if (img.complete && img.naturalWidth) return cb();
    var done = false;
    function go() { if (!done) { done = true; cb(); } }
    img.addEventListener('load', go);
    img.addEventListener('error', go);
    setTimeout(go, 2500);
  }

  function repaintArt() {
    S.views.forEach(function (v) {
      v.art = null;
      rerender(v);
    });
  }

  function rerender(view) {
    if (!view.ws) return;
    var data = view.ws.getDecodedData();
    if (!data) return;
    try {
      /* render() асинхронний, тож прогрес повертаємо ПІСЛЯ нього — інакше
         перемальована канва лишиться без заливки прослуханого до наступного
         timeupdate */
      Promise.resolve(view.ws.renderer.render(data)).then(function () {
        view.ws.updateProgress();
      });
    } catch (e) { /* не критично */ }
  }

  /* Обкладинка в офскрін-канву розміром з УСЮ доріжку (device px), щоб і хвиля,
     і прогрес брали ту саму картинку з тим самим кадруванням. */
  function buildArt(view) {
    var img = S.artImg;
    if (!img || !img.complete || !img.naturalWidth) return null;

    var dpr = Math.max(1, window.devicePixelRatio || 1);
    var w = Math.round(view.waveEl.clientWidth * dpr);
    var h = Math.round(view.opts.height * dpr);
    if (w < 2 || h < 2) return null;
    if (view.art && view.art.width === w && view.art.height === h) return view.art;

    var c = document.createElement('canvas');
    c.width = w;
    c.height = h;
    var g = c.getContext('2d');

    /* під прозорими краями обкладинки має бути щось непрозоре, інакше source-in
       нижче зітре смужки в тих місцях геть */
    g.fillStyle = view.opts.artBase;
    g.fillRect(0, 0, w, h);

    /* 🔑 Ліві кілька відсотків обкладинки відрізаємо: дюварп починається рівно з
       ребра передньої грані коробки, і світла грань лишається в кадрі сірою
       смужкою на початку хвилі. Праворуч такого немає — там чистий зріз.
       Робимо це ТУТ, а не в flatten_box: у Files лежить чесна пласка обкладинка,
       вона потрібна й для інших задач. Другий раз підрізати не треба. */
    var insetL = Math.round(img.naturalWidth * view.opts.artInset);
    var srcW = img.naturalWidth - insetL;
    var srcH = img.naturalHeight;

    /* object-fit: cover + точка фокусу по вертикалі (0..1) */
    var ir = srcW / srcH;
    var cr = w / h;
    var sw, sh, sx, sy;
    if (ir > cr) {
      sh = srcH;
      sw = sh * cr;
      sx = insetL + (srcW - sw) / 2;
      sy = 0;
    } else {
      sw = srcW;
      sh = sw / cr;
      sx = insetL;
      sy = (srcH - sh) * view.opts.artFocus;
    }
    g.drawImage(img, sx, sy, sw, sh, 0, 0, w, h);

    view.art = c;
    return c;
  }

  /* renderFunction замінює штатне малювання хвилі: спершу смужки суцільним
     кольором, тоді source-in підмінює заливку обкладинкою, тоді — притемнення
     НЕпрослуханої частини.

     Прослухане wavesurfer малює сам: КЛОНУЄ нашу канву і source-in заливає її
     progressColor. Щоб воно світилось тією ж обкладинкою на повну яскравість,
     підсовуємо туди CanvasPattern (convertColorValues віддає все, що не масив,
     як є).

     🔑 Писати патерн треба в `this`, а НЕ в ws.renderer.options: renderChannel
     робить КОПІЮ опцій, віддає її в renderFunction як this і рядком нижче читає
     progressColor саме з неї. Правка оригіналу мовчки нічого не робить, і
     прослухане лишається білим (дефолт wavesurfer). */
  function artRenderer(view) {
    return function (channels, ctx) {
      var o = view.opts;
      var dpr = Math.max(1, window.devicePixelRatio || 1);
      var cw = ctx.canvas.width;
      var ch = ctx.canvas.height;
      var left = (parseFloat(ctx.canvas.style.left) || 0) * dpr;

      drawBars(channels, ctx, o, dpr);

      var art = buildArt(view);
      if (!art) {
        /* обкладинка не доїхала — лишаємо смужки фірмовим кольором */
        ctx.globalCompositeOperation = 'source-in';
        ctx.fillStyle = o.waveColor;
        ctx.fillRect(0, 0, cw, ch);
        ctx.globalCompositeOperation = 'source-over';
        return;
      }

      ctx.globalCompositeOperation = 'source-in';
      ctx.drawImage(art, -left, 0);

      var dim = S.engaged ? o.dim : 0;
      if (dim > 0) {
        ctx.globalCompositeOperation = 'source-atop';
        ctx.fillStyle = 'rgba(0,0,0,' + dim + ')';
        ctx.fillRect(0, 0, cw, ch);
      }
      ctx.globalCompositeOperation = 'source-over';

      if (o.artProgress && this) {
        try {
          var pat = ctx.createPattern(art, 'no-repeat');
          if (pat && left && pat.setTransform) {
            pat.setTransform(new DOMMatrix([1, 0, 0, 1, -left, 0]));
          }
          if (pat) this.progressColor = pat;
        } catch (e) {
          /* лишаємо колір із опцій */
        }
      }
    };
  }

  /* Повторює штатний барний рендер wavesurfer один-в-один (ті самі abs, vScale і
     barIndexScale), бо renderFunction вимикає штатний — нам потрібен лише силует,
     колір дасть source-in вище. */
  function drawBars(channels, ctx, o, dpr) {
    var top = channels[0] || [];
    var bottom = channels[1] || top;
    var len = top.length;
    if (!len) return;

    var w = ctx.canvas.width;
    var half = ctx.canvas.height / 2;
    var barW = o.barWidth ? o.barWidth * dpr : 1;
    var barG = o.barGap ? o.barGap * dpr : (o.barWidth ? barW / 2 : 0);
    var step = barW + barG || 1;
    var radius = o.barRadius ? o.barRadius * dpr : 0;

    var vScale = 1;
    if (o.normalize) {
      var peak = 0;
      for (var k = 0; k < len; k++) {
        var av = Math.abs(top[k] || 0);
        if (av > peak) peak = av;
      }
      if (peak) vScale = 1 / peak;
    }

    var scale = w / step / len;
    ctx.fillStyle = '#ffffff';
    ctx.beginPath();
    var slot = 0, maxTop = 0, maxBottom = 0;
    for (var i = 0; i <= len; i++) {
      var next = Math.round(i * scale);
      if (next > slot) {
        var hTop = Math.round(maxTop * half * vScale);
        var hAll = hTop + Math.round(maxBottom * half * vScale) || 1;
        var x = slot * step;
        var y = half - hTop;
        if (radius && ctx.roundRect) ctx.roundRect(x, y, barW, hAll, radius);
        else ctx.rect(x, y, barW, hAll);
        slot = next;
        maxTop = 0;
        maxBottom = 0;
      }
      var a1 = Math.abs(top[i] || 0);
      var a2 = Math.abs(bottom[i] || 0);
      if (a1 > maxTop) maxTop = a1;
      if (a2 > maxBottom) maxBottom = a2;
    }
    ctx.fill();
    ctx.closePath();
  }

  /* ---------- вигляд ---------- */

  function paint(view, playing) {
    view.btn.innerHTML = playing ? ICON_PAUSE : ICON_PLAY;
    view.btn.setAttribute('aria-label', playing ? view.opts.labelPause : view.opts.labelPlay);
    view.el.classList.toggle('is-playing', !!playing);
  }

  function paintAll(playing) {
    S.views.forEach(function (v) { paint(v, playing); });
  }

  /* Перемикання «недоторканий / у роботі». Поки недоторканий — обкладинка на
     повну і курсора не видно; щойно пішло відтворення чи перемотка — хвиля
     притемнюється і прослухане знову світиться на повну. */
  function setEngaged(on) {
    if (S.engaged === on) return;
    S.engaged = on;
    S.views.forEach(function (v) {
      v.el.classList.toggle('is-engaged', on);
      rerender(v);
    });
  }

  /* 🔴 Перемотка ДО першого відтворення.
     З preload="none" у media ще немає даних (readyState 0), і присвоєння
     currentTime браузер може просто проковтнути: Chrome ставить його в чергу,
     а Safari/Firefox — ні, і клік по хвилі там «не мотає». Тому позицію
     запам'ятовуємо, підштовхуємо завантаження метаданих і переставляємо час,
     щойно вони приїдуть. Хвилю перемальовуємо одразу самі, не чекаючи звуку. */
  function holdSeek(time) {
    var a = S.audio;
    if (!a || !isFinite(time) || time < 0) return;
    paintProgress(time);
    if (a.readyState >= 1) {
      try { a.currentTime = time; } catch (e) { /* ігноруємо */ }
      return;
    }
    S.seekTo = time;
    if (a.preload === 'none') {
      a.preload = 'metadata';
      try { a.load(); } catch (e) { /* ігноруємо */ }
    }
    if (!a.saSeekHooked) {
      a.saSeekHooked = true;
      a.addEventListener('loadedmetadata', function () {
        if (S.seekTo == null) return;
        try { a.currentTime = S.seekTo; } catch (e) { /* ігноруємо */ }
        S.seekTo = null;
      });
    }
  }

  /* Показати позицію негайно, навіть якщо звук іще не доїхав. */
  function paintProgress(time) {
    var dur = S.duration || (S.audio ? S.audio.duration : 0);
    if (!dur || !isFinite(dur)) return;
    S.views.forEach(function (v) {
      if (v.cur) v.cur.textContent = fmt(time);
      if (!v.ws) return;
      try { v.ws.renderer.renderProgress(time / dur, false); } catch (e) { /* ігноруємо */ }
    });
  }

  function tick() {
    var cur = S.audio ? S.audio.currentTime || 0 : 0;
    var dur = S.duration || (S.audio ? S.audio.duration : 0);
    if (cur > 0.05) setEngaged(true);
    S.views.forEach(function (v) {
      if (v.cur) v.cur.textContent = fmt(cur);
      if (v.dur) v.dur.textContent = fmt(dur);
    });
  }

  /* ---------- створення інстансів ---------- */

  function createWS(view, useMasterData) {
    var o = view.opts;
    var cfg = {
      container: view.waveEl,
      media: S.audio,
      height: o.height,
      barWidth: o.barWidth,
      barGap: o.barGap,
      barRadius: o.barRadius,
      waveColor: o.waveColor,
      progressColor: o.progressColor,
      cursorWidth: o.cursorWidth,
      cursorColor: o.cursorColor,
      normalize: o.normalize
    };
    /* контейнер має бути порожній: wavesurfer не прибирає чужі вузли, і будь-який
       залишок лишиться висіти під новою хвилею */
    if (view.waveEl.firstElementChild) view.waveEl.innerHTML = '';
    if (o.art) cfg.renderFunction = artRenderer(view);
    if (useMasterData) {
      cfg.peaks = S.peaks;
      cfg.duration = S.duration;
    } else if (S.peaks && S.duration) {
      /* піки порахували заздалегідь — mp3 (десяток мегабайтів) поїде лише на play */
      cfg.peaks = S.peaks;
      cfg.duration = S.duration;
      cfg.url = S.url;
    } else {
      cfg.url = S.url;
    }
    view.ws = WaveSurfer.create(cfg);
    return view.ws;
  }

  function attach(view) {
    view.ws.on('play', function () { setEngaged(true); paintAll(true); });
    view.ws.on('pause', function () { paintAll(false); });
    view.ws.on('interaction', function (newTime) {
      setEngaged(true);
      holdSeek(newTime);
    });
    view.ws.on('timeupdate', tick);
    view.ws.on('finish', function () {
      view.ws.stop();
      paintAll(false);
      setEngaged(false);
      tick();
    });
    view.el.classList.remove('is-loading');
  }

  function bootSlaves() {
    S.views.forEach(function (v) {
      if (v.ws) return;
      createWS(v, true);
      attach(v);
    });
    tick();
  }

  /* 🔴 Обов'язкова сторожа. До view веде ДВА шляхи: bootSlaves() з події 'ready'
     майстра і власний whenArtReady() цього ж view. Хто прийде другим — без цієї
     перевірки створить ДРУГИЙ інстанс wavesurfer у тому самому контейнері:
     у блоці стає дві хвилі одна під одною, а кліки йдуть у верхню, осиротілу. */
  function boot(view) {
    if (view.ws) return;
    if (!S.master) {
      /* Перший змонтований плеєр тягне й декодує mp3; решта дістане готові
         піки і жодного разу не піде в мережу. */
      S.master = createWS(view, false);
      window.globalAudioPlayers.push({ instance: S.master, icon: null });
      S.master.on('ready', function (dur) {
        S.duration = dur;
        try { S.peaks = S.master.exportPeaks({ maxLength: 12000 }); } catch (e) { S.peaks = null; }
        if (S.peaks) bootSlaves();
        tick();
      });
      attach(view);
    } else if (S.peaks) {
      createWS(view, true);
      attach(view);
      tick();
    }
    /* інакше — підхопиться в bootSlaves(), коли майстер догрузиться */
  }

  /* ---------- перемир'я з ютубом ---------- */

  /* Одночасно має звучати щось одне. Ютуб живе в чужому айфреймі, тож:
     • щоб ДІЗНАТИСЬ про його play, треба спершу привітатись повідомленням
       "listening" — без цього YouTube не шле жодної події (потрібен enablejsapi=1,
       він є в snippets/sa-youtube.liquid);
     • щоб його ЗУПИНИТИ, шлемо команду pauseVideo.
     Аудіо глушимо через window.stopGlobalPlayers(null): null як «поточний» означає
     «зупинити геть усіх» — і демосонг, і семпли паку. */

  var ytBusy = false;      // щоб пауза через ютуб не зупинила сам ютуб

  function ytFrames() {
    return [].slice.call(document.querySelectorAll('iframe[src*="/embed/"]'))
      .filter(function (f) { return /youtube(-nocookie)?\.com/.test(f.src); });
  }

  function ytPost(frame, msg) {
    try { frame.contentWindow.postMessage(msg, '*'); } catch (e) { /* ще не готовий */ }
  }

  function ytListen() {
    ytFrames().forEach(function (f) {
      if (f.__saListening) return;
      f.__saListening = true;
      var hello = function () { ytPost(f, '{"event":"listening"}'); };
      f.addEventListener('load', hello);
      hello();
    });
  }

  function pauseVideos(except) {
    ytFrames().forEach(function (f) {
      if (except && (f === except || f.contentWindow === except)) return;
      ytPost(f, '{"event":"command","func":"pauseVideo","args":""}');
    });
  }

  function pauseAllAudio() {
    ytBusy = true;
    try {
      if (window.stopGlobalPlayers) window.stopGlobalPlayers(null);
    } finally {
      ytBusy = false;
    }
  }

  /* Будь-який плеєр сторінки (наш чи блок семплів) перед стартом кличе
     stopGlobalPlayers — обгортаємо його, щоб заодно глушив відео. */
  function bridgeStopGlobal() {
    var orig = window.stopGlobalPlayers;
    if (!orig || orig.__saBridged) return;
    var wrapped = function (current) {
      orig(current);
      if (!ytBusy) pauseVideos();
    };
    wrapped.__saBridged = true;
    window.stopGlobalPlayers = wrapped;
  }

  window.addEventListener('message', function (ev) {
    var host = '';
    try { host = new URL(ev.origin).hostname; } catch (e) { return; }
    if (!/(^|\.)youtube(-nocookie)?\.com$/.test(host)) return;
    var d = ev.data;
    if (typeof d === 'string') { try { d = JSON.parse(d); } catch (e) { return; } }
    if (!d || d.event !== 'infoDelivery' || !d.info || d.info.playerState !== 1) return;
    /* На сторінці паку відео ДВА (демосонг і огляд) — вони теж мусять глушити
       одне одного, інакше можна запустити обидва разом. */
    pauseAllAudio();
    pauseVideos(ev.source);
  }, false);

  function ytInit() {
    bridgeStopGlobal();
    ytListen();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { setTimeout(ytInit, 0); });
  } else {
    setTimeout(ytInit, 0);
  }
  /* айфрейми з loading="lazy" і ті, що створює фасад плагіна, під'їжджають пізніше */
  [1500, 4000, 9000].forEach(function (ms) { setTimeout(ytInit, ms); });

  /* ---------- публічний API ---------- */

  window.SADemo = {
    /* для дебагу/зовнішнього коду: спільний media-елемент усіх вейвформ */
    media: function () { return S.audio; },
    debug: function () {
      return {
        engaged: S.engaged,
        artUrl: S.artUrl,
        img: S.artImg ? (S.artImg.complete ? 'complete ' + S.artImg.naturalWidth : 'loading') : 'none',
        views: S.views.map(function (v) {
          return {
            id: v.el.id,
            ws: !!v.ws,
            optArt: !!v.opts.art,
            height: v.opts.height,
            waveW: v.waveEl.clientWidth,
            hosts: v.waveEl.children.length,
            artCanvas: v.art ? v.art.width + 'x' + v.art.height : null
          };
        })
      };
    },
    repaint: function () { repaintArt(); },
    mount: function (opts) {
      var el = typeof opts.el === 'string' ? document.querySelector(opts.el) : opts.el;
      if (!el || el.dataset.saDemoMounted) return;
      el.dataset.saDemoMounted = '1';

      var view = {
        el: el,
        waveEl: el.querySelector('[data-sa-wave]'),
        btn: el.querySelector('[data-sa-btn]'),
        cur: el.querySelector('[data-sa-cur]'),
        dur: el.querySelector('[data-sa-dur]'),
        ws: null,
        art: null,
        opts: {
          height: opts.height || 50,
          barWidth: opts.barWidth || 1,
          barGap: opts.barGap == null ? 1 : opts.barGap,
          barRadius: opts.barRadius || 0,
          waveColor: opts.waveColor || '#efe86c',
          progressColor: opts.progressColor || '#ffffff',
          cursorWidth: opts.cursorWidth == null ? 0 : opts.cursorWidth,
          cursorColor: opts.cursorColor || 'rgba(255,255,255,.65)',
          art: opts.art || null,
          artFocus: opts.artFocus == null ? 0.5 : opts.artFocus,
          artInset: opts.artInset == null ? 0.028 : opts.artInset,
          artBase: opts.artBase || '#2a1d10',
          artProgress: opts.artProgress !== false,
          dim: opts.dim == null ? 0.7 : opts.dim,
          normalize: opts.normalize !== false,
          labelPlay: opts.labelPlay || 'Play',
          labelPause: opts.labelPause || 'Pause'
        }
      };
      if (!view.waveEl || !view.btn) return;

      S.url = S.url || opts.url;
      if (!S.url) return;
      S.artUrl = S.artUrl || view.opts.art;
      if (!S.peaks && opts.peaks && opts.peaks.length && opts.duration) {
        S.peaks = [opts.peaks];
        S.duration = opts.duration;
      }

      paint(view, false);
      el.classList.add('is-loading');
      S.views.push(view);

      view.btn.addEventListener('click', function () {
        if (window.stopGlobalPlayers && S.master) window.stopGlobalPlayers(S.master);
        if (S.audio.paused) { S.audio.play(); } else { S.audio.pause(); }
      });

      if (!S.audio) {
        S.audio = new Audio();
        S.audio.crossOrigin = 'anonymous';
        S.audio.preload = S.peaks ? 'none' : 'metadata';

        window.globalAudioPlayers = window.globalAudioPlayers || [];
        if (!window.stopGlobalPlayers) {
          window.stopGlobalPlayers = function (current) {
            window.globalAudioPlayers.forEach(function (p) {
              if (p.instance !== current) {
                p.instance.stop();
                if (p.icon) p.icon.src = window.playLinkImg;
              }
            });
          };
        }
      }

      whenArtReady(function () { boot(view); });

      window.addEventListener('resize', function () { view.art = null; });
    }
  };
})();
